import { Injectable } from '@angular/core';
import { IMapper } from '@core/base/mapper.interface';
import { DocumentTypeEnum } from '@core/enums/document/document-type.enum';
import { IPolicyDocumentResponseDto } from '@core/interfaces/api/policies/policy-document-response-dto.interface';
import { IPolicyDetails } from '../interfaces/policy-document.interface';

interface IParamsPolicyToPageMapper extends IPolicyDocumentResponseDto {
  type: DocumentTypeEnum;
}

@Injectable()
export class PolicyToPageMapperService
  implements IMapper<IPolicyDocumentResponseDto, IPolicyDetails>
{
  mapTo(source: IParamsPolicyToPageMapper): IPolicyDetails {
    return {
      content: source.content,
      acceptedAt: source.acceptedAt ?? null,
      title: this.getPolicyTitle(source.type),
      type: source.type,
    };
  }

  private getPolicyTitle(policyType: DocumentTypeEnum): string {
    switch (policyType) {
      case DocumentTypeEnum.TERMS_OF_USE:
        return 'POLICY.TERMS_OF_USE.TITLE';
      case DocumentTypeEnum.PRIVACY_POLICY:
        return 'POLICY.PRIVACY_POLICY.TITLE';
      case DocumentTypeEnum.COOKIE_POLICY:
        return 'POLICY.COOKIES_POLICY.TITLE';
      default:
        return 'POLICY.TITLES.DEFAULT';
    }
  }
}
